import { refreshPage } from "./helpers/refreshPage";

export default async function handleBasketEvent(event) {
  if (event === "orderCreated") {
    window.location.href = InpostIziJavsscriptWoocommerce.thank_you_url;
    return Promise.resolve(true);
  }

  if (event === "basketProductChanged") {
    if (
      InpostIziJavsscriptWoocommerce.force_wc_fragments_refresh_after_basket_update &&
      window.jQuery
    ) {
      window.jQuery(document.body).trigger('wc_fragment_refresh');
    }
    refreshPage();
    return Promise.resolve(true);
  }

  if (event === "basketDeleted") {
    return Promise.resolve(true);
  }
}
